import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-2xl">
        <Card className="bg-zinc-900/50 border-white/5">
          <CardHeader className="text-center pb-2">
            <h1 className="text-3xl font-bold text-white">q<span className="text-blue-500">Pro</span></h1>
            <p className="text-zinc-500 text-sm mt-2">Privacy Policy</p>
          </CardHeader>
          <CardContent className="p-6 space-y-4 text-sm text-zinc-400">
            <p>
              qPro collects the account information you provide (name, email, password) and the
              documents you upload for comparison, solely to operate the quotation comparison
              service on your behalf.
            </p>
            <div>
              <h2 className="text-white font-semibold mb-1">Data we collect</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>Account details: email address, username, hashed password.</li>
                <li>Uploaded quotation/PO documents and the comparison results derived from them.</li>
                <li>Basic usage/audit data: login timestamps and IP address, for security purposes.</li>
              </ul>
            </div>
            <div>
              <h2 className="text-white font-semibold mb-1">How we use it</h2>
              <p>
                Uploaded documents are processed to generate comparison reports and are stored so you
                can retrieve past results. We do not sell or share your data with third parties for
                marketing purposes.
              </p>
            </div>
            <div>
              <h2 className="text-white font-semibold mb-1">Your controls</h2>
              <p>
                You can delete individual comparisons from the History page. To request full account
                deletion or export of your data, contact your administrator.
              </p>
            </div>
            <p className="text-zinc-500 text-xs pt-2 border-t border-white/5">
              Last updated: {new Date().getFullYear()}. This page describes qPro's current data
              handling practices and may be updated as the product evolves.
            </p>
            <div className="text-center pt-2">
              <Button onClick={() => navigate(-1)} variant="outline" className="border-zinc-700 text-zinc-300">
                <ArrowLeft size={16} className="mr-2" />Back
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
